module.exports = __webpack_public_path__ + "static/media/help-center.8071b85f.svg";